module.exports = __webpack_public_path__ + "img/bj_11.adadd63b.jpg";